import { getFirestore, collection, doc, getDoc, getDocs, updateDoc, setDoc, deleteDoc, serverTimestamp } from "firebase/firestore";
import Vue from "vue";
import Axios from "axios";
import VueAxios from "vue-axios";
import { resolveExerciseDocumentRef } from "@/utils/exerciseRef";

Vue.use(VueAxios, Axios);

const db = getFirestore();


Vue.use(VueAxios, Axios);

export default {
    state:{
        requestsExercisesList: [],
        exercisesByUsersList: []
    },
    mutations:{
        SET_REQUESTS_EXERCISES_LIST(state, requestsExercisesList){
            state.requestsExercisesList = requestsExercisesList
        },
        SET_EXERCISES_BY_USERS_LIST(state, exercisesByUsersList){
            state.exercisesByUsersList = exercisesByUsersList
        }
    },
    actions:{
        GoToSave({ }, request){
            return new Promise(async (resolve, reject) => {
                try {
                    const ref = doc(collection(db, "requestsForAddExercises"));
                    // const request = await ref.get();
                    console.log('ref', ref);
                    request.id = ref.id;
                    console.log(request);
                                         await setDoc(doc(db, "requestsForAddExercises", request.id), request)
                } catch (error) {
                    console.log(error);
                }
            })

        },
        GetRequestsExercisesList({ commit }){
            return new Promise(async (resolve, reject) => {
                try {
                    const querySnapshot = await getDocs(collection(db, "requestsForAddExercises"))
                    const requestsExercisesList = []
                    querySnapshot.forEach(async(doc) =>  {
                        const request = doc.data()
                        requestsExercisesList.push(request)
                    })
                    commit('SET_REQUESTS_EXERCISES_LIST', requestsExercisesList)
                    resolve(requestsExercisesList)
                } catch(error) {
                    reject(error)
                }
            })
        },
        GetExercisesByUsersList({ commit }){
            return new Promise(async (resolve, reject) => {
                try {
                    const querySnapshot = await getDocs(collection(db, "exercisesByUsers"))
                    const exercisesByUsersList = []
                    querySnapshot.forEach(async(doc) =>  {
                        const exerciseByUser = doc.data()
                        exercisesByUsersList.push(exerciseByUser)
                    })
                    commit('SET_EXERCISES_BY_USERS_LIST', exercisesByUsersList)
                    resolve(exercisesByUsersList)
                } catch(error) {
                    reject(error)
                }
            })
        },
        async GetEspecificExercise({}, exercise){
            return new Promise(async(resolve, reject) => {
                try {
                    // console.log('exercise', exercise.parent.id);
                    const collectionName = exercise.isReactNativeExercise || exercise.parent.id === 'excercisesNew' ? 'excercisesNew' : 'excercises'
                    const id = exercise.id
                                         const res = await getDoc(doc(db, collectionName, id))
                    let exerciseGetted = res.data()
                    exerciseGetted.id = id
                    resolve(exerciseGetted)
                } catch (error) {
                    reject(error)
                }
            })

        },
        UpdateRequestExercise({}, requestExercise) {
            return new Promise(async(resolve, reject) => {
                try {
                    requestExercise = {
                        ...requestExercise,
                        'request.updatedAt': serverTimestamp()
                    }
                                         await updateDoc(doc(db, "requestsForAddExercises", requestExercise.idRequest), requestExercise)
                    resolve(requestExercise.idRequest);
                } catch (error) {
                    reject(error);
                }
            });
        },
        SaveInAppExerciseRequest({ dispatch }, requestExercise){
            return new Promise(async(resolve, reject) => {
                try {
                    for (let i = 0; i < requestExercise.exercises.length; i++) {
                        const documentExercise = resolveExerciseDocumentRef(
                            requestExercise.exercises[i].exercise
                        );
                        if (documentExercise) {
                            requestExercise.exercises[i].exercise = documentExercise;
                        }
                    }

                    requestExercise.user = doc(db, 'users', requestExercise.user.uid)

                    const ref = doc(collection(db, "exercisesByUsers"));
                    const newExerciseByUser = await getDoc(ref);
                    requestExercise.id = ref.id;
                    requestExercise.request.savedOnDB = true
                    const payload = {
                        routeName: 'exercisesByUsers',
                        title: requestExercise.name,
                        id: requestExercise.idRequest,
                        img: null
                    }
                    
                    const dynamicLinks = await dispatch('GenerateDynamicLink', payload)
                    requestExercise.dynamicLink = dynamicLinks.shortLink
                    requestExercise.enabled = true
                    requestExercise.request.addedToAppDate = new Date()

                                         await setDoc(doc(db, "exercisesByUsers", newExerciseByUser.id), requestExercise)
                                         await updateDoc(doc(db, "requestsForAddExercises", requestExercise.idRequest), { 'request.savedOnDB': true })
                    resolve(newExerciseByUser.id);
                } catch (error) {
                    reject (error);
                }
            })

        },
        DisableExerciseByUser({}, exerciseByUser){
            return new Promise(async(resolve, reject) => {
                try {
                                         await updateDoc(doc(db, "exercisesByUsers", exerciseByUser.id), {
                        enabled: !exerciseByUser.enabled
                      })
                    resolve(exerciseByUser.id);
                } catch (error) {
                    reject(error);
                }
            });
        },
        DeleteRequestExercise({}, requestExercise) {
            return new Promise(async(resolve, reject) => {
                try {
                                         await deleteDoc(doc(db, "requestsForAddExercises", requestExercise.id))
                    resolve(requestExercise.id)
                } catch (error) {
                    reject(error);
                }
            });
        },
    },
    getters:{
        getRequestsExercisesList(state){
            return state.requestsExercisesList;
        },
        getExercisesByUsersList(state){
            return state.exercisesByUsersList;
        },
    }
}